export default "__VITE_ASSET__Cu7GN1Sv__"